module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rr-resizer",
    class: {
      'rr-resizer--active': !_vm.disabled && _vm.active
    },
    style: ({
      transform: 'rotateZ(' + _vm.state.rotation + 'deg)',
      left: _vm.state.left + 'px',
      top: _vm.state.top + 'px',
      width: _vm.state.width + 'px',
      height: _vm.state.height + 'px',
    })
  }, [(_vm.rotatable) ? _c('div', {
    ref: "rotateHandle",
    staticClass: "rr-rotatable-handle"
  }) : _vm._e(), _vm._v(" "), (_vm.hasHandle('n')) ? _c('div', {
    key: "ord-n",
    staticClass: "rr-resizable-handle rr-resizable-n"
  }) : _vm._e(), _vm._v(" "), (_vm.hasHandle('s')) ? _c('div', {
    key: "ord-s",
    staticClass: "rr-resizable-handle rr-resizable-s"
  }) : _vm._e(), _vm._v(" "), (_vm.hasHandle('e')) ? _c('div', {
    key: "ord-e",
    staticClass: "rr-resizable-handle rr-resizable-e"
  }) : _vm._e(), _vm._v(" "), (_vm.hasHandle('w')) ? _c('div', {
    key: "ord-w",
    staticClass: "rr-resizable-handle rr-resizable-w"
  }) : _vm._e(), _vm._v(" "), (_vm.hasHandle('nw')) ? _c('div', {
    key: "ord-nw",
    staticClass: "rr-resizable-handle rr-resizable-nw"
  }) : _vm._e(), _vm._v(" "), (_vm.hasHandle('ne')) ? _c('div', {
    key: "ord-ne",
    staticClass: "rr-resizable-handle rr-resizable-ne"
  }) : _vm._e(), _vm._v(" "), (_vm.hasHandle('se')) ? _c('div', {
    key: "ord-se",
    staticClass: "rr-resizable-handle rr-resizable-se"
  }) : _vm._e(), _vm._v(" "), (_vm.hasHandle('sw')) ? _c('div', {
    key: "ord-sw",
    staticClass: "rr-resizable-handle rr-resizable-sw"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "rr-resizer-content"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-649f59b0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Resizer.vue
// module id = 20
// module chunks = 0